import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  button: {
    '&.MuiButton-root': {
      minWidth: theme.spacing(12.5),
      textTransform: 'capitalize',
    },
  },

  decline: {
    marginRight: theme.spacing(2),

    '&.MuiButton-root': {
      color: theme.palette.text.primary,
      border: `${theme.spacing(0.125)} solid ${theme.palette.error.light}`,

      '&:hover': {
        border: `${theme.spacing(0.125)} solid ${theme.palette.error.light}`,
        backgroundColor: theme.palette.error.light,
      },
    },
  },
}));
